// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 736 ? "vendor" : chunkId) + ".bundle.js?" + {"449":"77e3ca6711d007bd6bef","736":"be4e1de05832a2b0dde9"}[chunkId] + "";
};